import { BudgetGoalsListPage } from './imports';

export const budgetGoalsRoutes = [
  {
    path: 'budget-goals',
    children: [
      { element: <BudgetGoalsListPage />, index: true },
      { path: 'list', element: <BudgetGoalsListPage /> },
    ],
  },
];
